import { useEffect, useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import { AccordionItem } from "../../AccordianItem";
import { Group, Radio, useMantineColorScheme } from "@mantine/core";
import { addedStepsAtom } from "../../../utils/atoms/addedStepsAtom";
import { useAtom } from "jotai";
import { componentsAtom } from "../../../utils/atoms/componentsAtom";
import { useHelpFocusBlur } from "../../../utils/useHelpFocusBlur";


function PVUpload({ updateData, selectedValue }) {
  const { t } = useTranslation();
  const { colorScheme } = useMantineColorScheme();
  const [addedStepsSeries] = useAtom(addedStepsAtom);
  const [pvScenario, setPvScenario] = useState(selectedValue);
  const containerRef = useRef(null);
  // Dummy atoms for help logic, replace with actual atoms if needed
  const [helperAtom, setHelperAtom] = useState({});

  useHelpFocusBlur(containerRef, setHelperAtom, helperAtom);

  useEffect(() => {
    handlePvScenarioChange(selectedValue);
  }, [selectedValue]);
  const handleContainerClick = (event) => {
    const interactiveTags = ["INPUT", "SELECT", "TEXTAREA", "BUTTON", "LABEL"];
    if (interactiveTags.includes(event.target.tagName)) return;
    const cardElement = document.querySelector('[card-id="accordion-pv-1"]');
    if (cardElement) {
      cardElement.scrollIntoView({ behavior: "smooth", block: "center" });
      cardElement.style.transition = "background-color 0.5s ease";
      cardElement.style.border = "2px solid #42b4e6";
      setTimeout(() => {
        cardElement.style.border = "";
      }, 2000);
    }
  };

  const handleContainerKeyDown = (event) => {
    if (event.target !== event.currentTarget) return;
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      handleContainerClick(event);
    }
  };
  const handlePvScenarioChange = (value) => {
    setPvScenario(value);
    updateData(value);
  };

  const header = () => (
    <>
      <span className="stepText col-md-1 px-0">
        {`Step ${addedStepsSeries.indexOf("pv") + 1}`}: A.
      </span>
      <span
        className={`ms-2 col-md-8 px-0 ${
          colorScheme === "dark" ? "se-white" : "se-accordian-title"
        }`}
      >
        {t("PVInstallation")}
      </span>
    </>
  );

  const children = () => (
    <div
      ref={containerRef}
      onClick={handleContainerClick}
      onKeyDown={handleContainerKeyDown}
      tabIndex={0}
      role="button"
    >
      <Radio.Group value={pvScenario} onChange={handlePvScenarioChange}>
        <Group mt="xs">
          <Radio value="new" label={t("pv.radio.new")} color="seGreen.0" data-id="pv-radio-new" />
          <Radio value="existing" label={t("pv.radio.existing")} color="seGreen.0" data-id="pv-radio-existing" />
        </Group>
      </Radio.Group>
    </div>
  );

  return (
    <AccordionItem id={1} header={header()} key={1} children={children()} />
  );
}
export default PVUpload;
